import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { clinicInfo } from '../data/mockData';

const QuickContact = () => {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3">
      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${clinicInfo.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all group flex items-center justify-center"
        aria-label="WhatsApp ile iletişime geç"
      >
        <MessageCircle className="h-6 w-6 group-hover:scale-110 transition-transform" />
      </a>

      {/* Phone Button */}
      <a
        href={`tel:${clinicInfo.phone}`}
        className="bg-emerald-700 hover:bg-emerald-800 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all group flex items-center justify-center"
        aria-label="Telefon ile ara"
      >
        <Phone className="h-6 w-6 group-hover:scale-110 transition-transform" />
      </a>
    </div>
  );
};

export default QuickContact;
